<template>
    <div class="mt-2" ref="loader">
        <b-container class="container-lg">
            <b-row class="pb-2">
                <b-col class="text-start">
                    <h5><i class="fa-solid fa-chevron-left" @click="goBack"></i> <i class="fa-solid fa-info-circle"></i> {{ $t('Statuspages') }}</h5>
                </b-col>
                <b-col class="text-end">
                    <button type="button" class="btn btn-light btn-sm" @click="refreshData">
                        <i class="fa-solid fa-arrows-rotate"
                           :class="{'fa-spin': loading}"></i>
                    </button>
                </b-col>
            </b-row>
            <b-list-group>
                <b-list-group-item>
                    <div class="row">
                        <div class="col">
                            <b-button v-b-toggle.filter class="m-0 w-100" variant="primary">
                                <i class="fa-solid fa-filter"></i>
                                {{ $t('Filter') }}
                            </b-button>
                        </div>
                    </div>
                    <b-collapse id="filter">

                        <div class="d-flex w-100 mt-2">
                            <b-form-input v-model="name" :placeholder="$t('name')"></b-form-input>
                        </div>
                        <div class="d-flex w-100 mt-2">
                            <b-form-input v-model="description" :placeholder="$t('description')"></b-form-input>
                        </div>
                        <div class="mt-2">
                            <b-button
                                class="w-100"
                                variant="outline-danger"
                                v-on:click="allFilter">{{ $t('filter.reset-filter') }}
                            </b-button>
                        </div>
                    </b-collapse>
                </b-list-group-item>
            </b-list-group>

            <!-- start new list -->
            <b-list-group
                v-for="statuspage in statuspages"
                v-bind:key="statuspage.id"
                class="mt-2">


                <div class="flex-column align-items-start">
                    <div class="list-group-item flex-column align-items-start list-group-item-action ps-0">
                        <div class="d-flex flex-row">
                            <div class="p-2">
                                <div class="h-100 status-line"
                                     v-bind:class="['bg-'+statuspage.css_color, 'shadow-'+statuspage.css_color]">
                                </div>
                            </div>
                            <div class="min-width-0">
                                <div class="row p-2">
                                    <div class="col-12 text-truncate h5">
                                        <router-link
                                            class="link-underline link-underline-opacity-0"
                                            :to="{name: 'statuspagesDetails', params: {id: statuspage.id}}">
                                            {{ statuspage.name }}
                                        </router-link>
                                    </div>
                                    <div class="col-12 text-truncate">
                                        <div class="row">
                                            <div class="col-12 text-truncate">
                                                {{ statuspage.description }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </b-list-group>
            <!-- end new list -->

            <b-list-group class="mt-3">
                <div v-if="statuspages.length > 0">
                    <div class="d-flex w-100 justify-content-between">
                        <small>{{ $t('page') }} {{ paging.page }}</small>
                        <small>{{ $t('pagesize') }} {{ paging.limit }}</small>
                    </div>
                    <div class="d-flex w-100 justify-content-center mt-4">
                        <vue-awesome-paginate
                            :total-items="paging.count"
                            :items-per-page="25"
                            :max-pages-shown="5"
                            v-model="paging.page"
                            :on-click="getIndex"
                        />
                    </div>
                </div>
                <b-list-group-item v-if="statuspages.length === 0">
                    <h5 class="mb-1">{{ $t('noitems') }}</h5>
                </b-list-group-item>
            </b-list-group>
        </b-container>
    </div>

</template>
<script>
import {debounce} from "../../helpers";
import Priority from "../utils/Priority.vue";
import Servicestatus from "../utils/Servicestatus.vue";
import DateSwitch from "../utils/DateSwitch.vue";
import {useToast} from "vue-toastification";
import {VueAwesomePaginate} from "vue-awesome-paginate";
import { BListGroup } from 'bootstrap-vue-next';

export default {
    name: "StatuspagesIndex",
    components: {BListGroup, VueAwesomePaginate, DateSwitch, Servicestatus, Priority},
    data(){
        return {
            loading: true,
            requestStatus: false,
            listFilter: {
                filter: {
                    id: [],
                    name: '',
                    description: "",
                }
            },
            statuspages: [],
            paging: {
                page: 1,
                pageCount: 1,
            },
            name: '',
            description: '',
        }
    },
    mounted(){
        this.getIndex();
    },
    methods: {
        getIndex: function(page = 1){
            let loader = this.$loading.show();
            this.loading = true;
            axios.post('/statuspages/index.json', {
                    filter: this.listFilter,
                    page: page
                },
                {
                    params: {}
                }
            )
                .then(response => {
                    this.requestStatus = true;
                    let pages = response.data.statuspages.all_statuspages ?? [];
                    this.permissions = response.data.permissions;
                    this.paging = response.data.statuspages.paging ?? {
                        page: 1,
                        pageCount: 1,
                    };
                    if(pages.length > 0){
                        pages.sort(function(a, b){
                            return b.cumulatedState - a.cumulatedState
                        });
                    }
                    this.statuspages = pages;
                })
                .catch(error => {
                    console.log(error)
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });

                })
                .finally(() => {
                    loader.hide();
                    this.loading = false;
                });
        },
        allFilter: function(){
            this.resetFilter();
            this.getIndex();
        },
        resetFilter: function(){
            this.name = null;
            this.description = null;

            this.listFilter = {
                filter: {
                    id: [],
                    name: '',
                    description: "",
                }
            };
        },
        refreshData: function(){
            this.resetFilter();
            this.getIndex();
        },
        goBack: function(){
            this.$router.back();
        }
    },
    watch: {
        name: debounce(function(newValue){
            if(newValue != null){
                this.listFilter.filter.name = newValue;
                this.getIndex();
            }
        }, 700),
        description: debounce(function(newValue){
            if(newValue != null){
                this.listFilter.filter.description = newValue;
                this.getIndex();
            }
        }, 700),
    }

}
</script>

<style scoped>

</style>
